import { graphql } from "gatsby";
import * as React from "react";
import useAuthorsMetadata from "../components/author/staticAuthorsData";
import Blog from "../components/blog";
import Comment from "../components/comment";
import { SimpleCentered } from "../components/headers/simplecentered";
import SplitWithImageRelative from "../components/headers/splitWithImageRelative";
import HeaderFooter from "../components/layouts/headerfooter";
import { BlankSection, BlankSectionNotSpacing } from "../components/layouts/section";
import SimilarArticle from "../components/similarArticle";

export default function BlogPostTemplate({ data, location }) {
  const { nodes } = useAuthorsMetadata();

  const { frontmatter, html } = data.article;

  const pageUrl = location.pathname;

  const returnUrl = location?.state?.categorySlug;

  return (
    <>
      <HeaderFooter
        title={frontmatter.title}
        description={frontmatter.description}
        keywords={frontmatter.keywords}
        location={location}
      >
        <BlankSection>
          {
            frontmatter.featureImage ? (
              <SplitWithImageRelative
                heading={frontmatter.title}
                image={frontmatter.featureImage}
                headerClass="text-4xl lg:text-4xl"
                category={frontmatter.category.name}
                isContentful={true}
              />
            ) : (
              <SimpleCentered
                title={frontmatter.title}
                category={frontmatter.category && frontmatter.category[0]}
              />
            )
          }
        </BlankSection>

        <BlankSectionNotSpacing>
          <Blog
            publishedDate={frontmatter.date}
            author={frontmatter.author}
            body={html}
            nodes={nodes}
            returnUrl={returnUrl}
          />
        </BlankSectionNotSpacing>

        <BlankSectionNotSpacing bgClass='mb-12'>
          <Comment pageUrl={pageUrl} title={frontmatter.title} id={frontmatter.description} />
        </BlankSectionNotSpacing>

        <BlankSectionNotSpacing>
          {
            frontmatter && (
              <SimilarArticle
                category={frontmatter.category[0]}
                keywords={frontmatter.keywords}
                currentArticleSlug={frontmatter.slug}
              />
            )
          }
        </BlankSectionNotSpacing>

      </HeaderFooter>
    </>
  );
}

export const pageQuery = graphql`
  query ($id: String!) {
      article: markdownRemark(id: { eq: $id }
    ) {
      id
      html
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        title
        category: categories
        description
        keywords
        author
        slug
      }
    }
  }
`;
